// show or hide file extension
// regex: http://movingtofreedom.org/2008/04/01/regex-match-filename-base-and-extension/
export function extension(string, showExtension) {
    if (!string) { return ''; }
    return (showExtension) ? string : string.replace(/(.+?)(\.[^.]*$|$)/, '$1');
}
